import { Site } from '@envato/foundation-types'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { IRootState } from '../../../common/reducers'
import { ILocationParams } from '../../../common/reducers/reactRouterLocation'
import { getSearchLocationParams } from '../../../common/utils/location'
import ItemCard from './itemCard'

import { IDecoratedItem } from '../../../typings/searchResults'

type IItemCardWithRoute = RouteComponentProps<any> & IDecoratedItem

interface IOwnProps extends IItemCardWithRoute {
  viewType?: string
  isCardHovered?: boolean
  isCardFocused?: boolean
}

interface IStateProps {
  currentSite: Site
  viewType: string
  locationParams: ILocationParams
}

const mapStateToProps = (
  state: IRootState,
  ownProps: IOwnProps
): IStateProps => {
  const {
    common: { currentSite },
    user: { preferences },
    router: { location },
    experiments
  } = state
  const { viewType } = ownProps
  const nextViewType = viewType || preferences.searchResultsViewType
  const locationParams = getSearchLocationParams({
    location,
    currentSite,
    experiments,
    routeMatch: ownProps.match
  })

  return {
    currentSite,
    viewType: nextViewType,
    locationParams
  }
}

export type IProps = IOwnProps & IStateProps

const ItemCardContainer = connect<IStateProps, {}, IOwnProps, IRootState>(
  mapStateToProps
)(ItemCard)

export default withRouter(ItemCardContainer)
